import React from 'react'
import {graphql, useStaticQuery} from "gatsby"

import confStyles from './confidence_picks.module.scss'
import ConfMatchup from './helpers/confidence_matchup'
import ConfRank from './helpers/conf_rank'



const ConfPicksNew = () => {

    const data = useStaticQuery(graphql`
        query {
            allProjectedSpreadsCsv (
                sort: {
                    fields:[
                        home_probability_nfelo
                    ]
                    order: DESC
                }
            ) {
            nodes {
                game_id
                season
                week
                home_team
                away_team
                home_team_name
                away_team_name
                home_team_logo_espn
                away_team_logo_espn
                home_line_close
                home_closing_line_rounded_nfelo
                home_ev
                away_ev
                home_probability_nfelo
            }
            }
        }
    `)

    function GetSortOrder(prop) {
        return function(a, b)  {
            if (Math.abs(a[prop]-.5) < Math.abs(b[prop]-.5)) {
                return;
            } else if (Math.abs(a[prop]-.5) > Math.abs(b[prop]-.5)) {
                return -1;
            } else {
                return 0;
            }
        }
    }

    data.allProjectedSpreadsCsv.nodes.sort(GetSortOrder('home_probability_nfelo')) 

    return (

        <div className={confStyles.pickContainer}>
            <div className={confStyles.perfCallOutDiv}>
                <h3 className={confStyles.perfCallHeader}>
                    NFL Confidence Picks:  Week {data.allProjectedSpreadsCsv.nodes[0]['week']}, {data.allProjectedSpreadsCsv.nodes[0]['season']}
                </h3>
                <p className={confStyles.perfCallP}>
                    Below are the nfelo model's picks ranked by confidence (16 is most confident)
                </p>
                <p className={confStyles.perfCallP}>
                    nfelo is one of the most accurate NFL prediction models on the internet and has picked winners more accurately than the Vegas line in back tests dating back to 2009
                </p>
                <div className={confStyles.spacer}></div>
            </div>
            <table className={confStyles.pickTable}>
                <thead className={confStyles.pickTableHeader}>
                    <tr className={confStyles.pickTableHeaderRow}>
                        <th className={confStyles.pickTableHeaderItem}>
                            <div className={confStyles.pickField}>
                                Confidence Rank
                            </div>
                        </th>
                        <th className={confStyles.pickTableHeaderItem}>
                            <div className={confStyles.pickField}>
                                Winner
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {data.allProjectedSpreadsCsv.nodes.map(node => {
                        return(
                            <tr
                                className={confStyles.pickTableRow}
                                key = {data.allProjectedSpreadsCsv.nodes.indexOf(node)}
                            >
                                <ConfRank
                                    week={node.week}
                                    season={node.season}
                                    homeTeam={node.home_team_name}
                                    awayTeam={node.away_team_name}
                                    rank={16-data.allProjectedSpreadsCsv.nodes.indexOf(node)}
                                />
                                <ConfMatchup
                                    week={node.week}
                                    season={node.season}
                                    homeTeam={node.home_team_name}
                                    homeTeamSmall={node.home_team}
                                    homeConf={node.home_probability_nfelo}
                                    homeLogo={node.home_team_logo_espn}
                                    awayTeam={node.away_team_name}
                                    awayTeamSmall={node.away_team}
                                    awayConf={1 - parseFloat(node.home_probability_nfelo)}
                                    awayLogo={node.away_team_logo_espn} 
                                />
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}

export default ConfPicksNew